var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAspectRatio = function SvgAspectRatio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#AspectRatio_svg__a)",
    strokeWidth: 0.8,
    d: "M1.357 4.533c0-1.885 0-2.828.521-3.414.52-.586 1.359-.586 3.035-.586h1.778c1.676 0 2.514 0 3.035.586.52.586.52 1.529.52 3.414s0 2.829-.52 3.415c-.521.585-1.36.585-3.035.585H4.913c-1.676 0-2.514 0-3.035-.585-.52-.586-.52-1.529-.52-3.415Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#AspectRatio_svg__b)",
    strokeWidth: 0.8,
    d: "M1.357 3.2h3.556c1.257 0 1.886 0 2.276.39.39.391.39 1.02.39 2.277v2.666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#AspectRatio_svg__c)",
    strokeWidth: 0.8,
    d: "M4.913 8.533V3.2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AspectRatio_svg__a",
    x1: 5.802,
    x2: 5.802,
    y1: 0.533,
    y2: 8.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AspectRatio_svg__b",
    x1: 4.469,
    x2: 4.469,
    y1: 3.2,
    y2: 8.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7BDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AspectRatio_svg__c",
    x1: 5.413,
    x2: 5.413,
    y1: 3.2,
    y2: 8.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7BDB"
  })))));
};
export default SvgAspectRatio;